module.exports = {
  title: '爱妃百货',
  login: {
    username: '請輸入用戶名',
    password: '請輸入密碼',
    Username: '用戶名',
    Password: '密碼',
    login: '登录',
    Email: '邮箱',
    Mobile: '手机',
    register: '注册',
    CreateAnAccount: '创建账号',
    exit: '退出',
    ForgotPassword: '忘记密码',
    CreateAccount: '创建账号',
    RegisterType: '注册方式',
    VerificationCode: '验证码',
    phone: '手机号',
    inspectPassword: '确认密码',
    Emailverify: '邮箱不能为空',
    Passwordverify: '密码不能为空',
    inspectPasswordverify: '确认密码不能为空',
    Phoneverify: '手机号不能为空',
    Passwordformat: '密码格式错误,长度必须>3',
    inspectPasswordformat: '确认密码格式错误,长度必须>3，且必须等于密码',
    userName: '',
  },
  home: {
    Categories: '类别',
    search: '搜索',
    lang: '中文',
    placeholder: '搜索商品/店铺',
  },
  Goods: {
    CartBtn: '加入购物车',
    BuyBtn: '购买',
    Subtotal: '总计',
  },
  form: {
    submit: '提交',
  },
};
